import React, { useEffect, useRef, useState } from "react";
// MUI
import { CircularProgress, Grid2, LinearProgress } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
// Styling
import styles from "./WordpressLoginDetails.module.scss";
// Local imports
import CustomInput from "../../../../../../GlobalComponents/CustomInput/CustomInput";
import {
  millisecondsToRoundedHours,
  verifyPassword,
} from "../../../../../../Utils/utils";
import { WordpressConstantText } from "../ConstantData/CreateSiteConstantData";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
import CustomButton from "../../../../../../GlobalComponents/CustomButton/CustomButton";
import NewPopup from "../../../../../../GlobalComponents/Popup/NewPopup";
import BuyStaging from "../BuyStaging/BuyStaging";
import { cashfreeSubscriptionSessionIdDecrypt } from "../../../../../../Utils/cashfree";
import FormPopup from "../../../../../../GlobalComponents/FormPopup/FormPopup";
import { useSelector } from "react-redux";
import {
  buildsV1Sites,
  sshPasswordErrorMessage,
  verifySshPassword,
} from "../../../../../../Utils/roconConstants";
import SshAccessOption from "./SshAccessOption";

// New managed sites are EBS (v2) sites, which have no staging environment.
// The backend ignores DEVELOPMENT for v2 anyway; this only hides the option.
// The orgs that still build v1 sites (buildsV1Sites) keep it.
const STAGING_AT_CREATE = false;

export default function WordpressLoginDetails(props) {
  const {
    isInput,
    setIsInput,
    showEnvironment,
    setShowEnvironment,
    nameLoading,
    setNameLoading,
    nameValid,
    setNameValid,
    selectedCountry,
    orgId,
    priceId,
    isLoading,
    setIsLoading,
    dedicatedHosting,
  } = props;
  const maxLength = 25;
  const minLength = 3;
  const targetRef = useRef(null);

  const [isExtend, setIsExtend] = useState(false);
  const [quantity, setQuantity] = useState(0);

  const [isChecked, setIsChecked] = useState(false);
  const stagingplan = useSelector((state) =>
    state.plansInfo?.specificPlan?.specificPlans.find(
      (item) => item.licenseType === "Staging",
    ),
  );
  const limits = parseInt(
    stagingplan?.featureDetails.find((item) => item.type === "STAGING")
      ?.limitOrAvailablity,
  );

  const { stagingCredits, usedCreditsTs } = useSelector((state) => ({
    stagingCredits: state.sitesInfo?.credits?.stagingCredits,
    usedCreditsTs: state.sitesInfo?.credits?.usedTs,
  }));

  let usedCredits = millisecondsToRoundedHours(usedCreditsTs);

  //popup
  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupSubtitle1: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupButtonFunction: () => {},
  });

  const ActivatePopup = (type) => {
    if (type === "error") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "something went wrong",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    }
    if (type === "success_staging") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Hurray it's done!!",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "none") {
      setPopup({ popupState: false });
    }
  };

  const handleSlider = () => {
    if (!isExtend) {
      setIsChecked(false);
    }
    setIsExtend(!isExtend);
  };

  const scrollEnvironment = () => {
    setTimeout(() => {
      targetRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }, 100);
  };

  const handleAddEnvironment = () => {
    setShowEnvironment(!showEnvironment);
    scrollEnvironment();
  };

  const handleDeleteEnvironment = () => {
    setShowEnvironment(false);
    setIsInput({
      ...isInput,
      tempdomainnamedev: "",
      wordpresspassworddev: "",
      wordpressusernamedev: "",
      wordpressconfirmpassworddev: "",
    });
  };

  useEffect(() => {
    const myTimeout = setTimeout(() => {
      if (isInput?.sitename?.length >= 3) {
        let currentSiteName = isInput?.sitename;
        const sitenameElement = document.getElementById(
          "createsiteform-sitename",
        );
        if (sitenameElement) {
          // Set nameLoading to true before starting the API call
          setNameLoading(true);
          getStore().dispatch({
            type: Actions.API_IS_VALID_SITE,
            siteName: isInput.sitename,
            isDedicated: dedicatedHosting,
            meta: {
              onSuccess: () => {
                // Stop nameLoading after API success
                setNameLoading(false);
                setNameValid(true);
                if (currentSiteName === sitenameElement.value) {
                  setIsInput({
                    ...isInput,
                    sitenameerror: false,
                    sitename: isInput.sitename.toLowerCase(),
                    tempdomainnameerror: false,
                    tempdomainname: isInput.sitename.toLowerCase(),
                  });
                }
              },
              onError: () => {
                // Stop nameLoading after API error
                setNameLoading(false);
                setNameValid(false);
                if (currentSiteName === sitenameElement.value) {
                  setIsInput({
                    ...isInput,
                    sitenameerror: true,
                    sitename: isInput.sitename.toLowerCase(),
                    tempdomainnameerror: false,
                    tempdomainname: isInput.sitename.toLowerCase(),
                  });
                }
              },
            },
          });
        }
      }
    }, 500);
    return () => {
      clearTimeout(myTimeout);
    };
  }, [isInput?.sitename]);

  useEffect(() => {
    const myTimeout = setTimeout(() => {
      if (isInput?.tempdomainnamedev?.length >= 3) {
        let currenttempdomainnamedev = isInput?.tempdomainnamedev;
        const tempdomainnamedevElement = document.getElementById(
          "createsiteform-tempdomainnamedev",
        );
        if (tempdomainnamedevElement) {
          // Set nameLoading to true before starting the API call
          setNameLoading(true);
          getStore().dispatch({
            type: Actions.API_IS_VALID_SITE,
            siteName: isInput.tempdomainnamedev,
            isDedicated: dedicatedHosting,
            meta: {
              onSuccess: () => {
                // Stop nameLoading after API success
                setNameLoading(false);
                setNameValid(true);
                if (
                  currenttempdomainnamedev === tempdomainnamedevElement.value
                ) {
                  setIsInput({
                    ...isInput,
                    tempdomainnamedeverror: false,
                    tempdomainnamedev: isInput.tempdomainnamedev.toLowerCase(),
                  });
                }
              },
              onError: () => {
                // Stop nameLoading after API error
                setNameLoading(false);
                setNameValid(false);
                if (
                  currenttempdomainnamedev === tempdomainnamedevElement.value
                ) {
                  setIsInput({
                    ...isInput,
                    tempdomainnamedeverror: true,
                    tempdomainnamedev: isInput.tempdomainnamedev.toLowerCase(),
                  });
                }
              },
            },
          });
        }
      }
    }, 500);
    return () => {
      clearTimeout(myTimeout);
    };
  }, [isInput?.tempdomainnamedev]);

  // SSH password (every v2 site has SSH; the password is chosen at creation). It never
  // leaves page state: it goes to the create call once and is shown on the ready page once.
  // Functional update: the generated default arrives right after mount and must not
  // overwrite other fields.
  const updateSshPassword = (value) =>
    setIsInput((prev) => {
      const sshpassword = (value || "").replace(/\s/g, "");
      return {
        ...prev,
        sshpassword,
        sshpassworderror: !verifySshPassword(sshpassword, prev.wordpresspassword),
      };
    });
  // live, so a later change of the WordPress password that collides is flagged too;
  // tells the owner which rule is broken (format vs. same as the WordPress password)
  const sshErrorMessage = sshPasswordErrorMessage(
    isInput?.sshpassword,
    isInput?.wordpresspassword,
  );

  const fromFieldUpdate = (value, type) => {
    if (type === "Site Name") {
      const startsWithNonDigit = /^[^0-9]/;
      if (value !== "" && !startsWithNonDigit.test(value)) {
        return;
      }
      value = value.toLowerCase().replace(/[^a-zA-Z0-9]/g, "");
      const maxLength = 25;
      if (value.length > maxLength) {
        value = value.substr(0, maxLength);
      }
      const regExForNumberNotInStart = /^[^0-9]/;
      if (value.length <= 3 && regExForNumberNotInStart.test(value)) {
        setIsInput({
          ...isInput,
          sitenameerror: false,
          sitename: value,
          tempdomainnameerror: null,
          tempdomainname: value,
        });
      } else {
        setIsInput({
          ...isInput,
          sitenameerror: false,
          sitename: value,
          tempdomainnameerror: false,
          tempdomainname: value,
        });
      }
    } else if (type === "Temporary Domain Name") {
      value = value.toLowerCase().replace(/[^a-zA-Z0-9]/g, "");
      if (value.length <= 3) {
        setIsInput({
          ...isInput,
          tempdomainnameerror: true,
          tempdomainname: value,
        });
      } else {
        setIsInput({
          ...isInput,
          tempdomainnameerror: false,
          tempdomainname: value,
        });
      }
    } else if (type === "WordPress Admin Username") {
      value = value.toLowerCase().replace(/[^a-zA-Z0-9]/g, "");
      setIsInput({
        ...isInput,
        wordpressusernameerror: false,
        wordpressusername: value,
      });
    } else if (type === "WordPress Admin Password") {
      value = value.replace(/\s/g, "");
      if (!verifyPassword(value)) {
        setIsInput({
          ...isInput,
          wordpresspassworderror: true,
          wordpresspassword: value,
        });
      } else {
        setIsInput({
          ...isInput,
          wordpresspassworderror: false,
          wordpressconfirmpassworderror: false,
          wordpresspassword: value,
        });
      }
    } else if (type === "WordPress Confirm Password") {
      value = value.replace(/\s/g, "");
      if (!verifyPassword(value)) {
        setIsInput({
          ...isInput,
          wordpressconfirmpassworderror: true,
          wordpressconfirmpassworderrormessage: "",
          wordpressconfirmpassword: value,
        });
      } else if (value !== isInput.wordpresspassword) {
        setIsInput({
          ...isInput,
          wordpressconfirmpassworderror: true,
          wordpressconfirmpassworderrormessage: "Passwords do not match.",
          wordpressconfirmpassword: value,
        });
      } else {
        setIsInput({
          ...isInput,
          wordpressconfirmpassworderror: false,
          wordpressconfirmpassworderrormessage: "",
          wordpressconfirmpassword: value,
        });
      }
    }
  };

  const fromFieldUpdateEnv = (value, type) => {
    if (type === "Temporary Domain Name") {
      const startsWithNonDigit = /^[^0-9]/;
      if (value !== "" && !startsWithNonDigit.test(value)) {
        return;
      }
      value = value.toLowerCase().replace(/[^a-zA-Z0-9]/g, "");
      const maxLength = 25;
      if (value.length > maxLength) {
        value = value.substr(0, maxLength);
      }
      const regExForNumberNotInStart = /^[^0-9]/;
      if (value.length <= 3 && regExForNumberNotInStart.test(value)) {
        setIsInput({
          ...isInput,
          tempdomainnamedeverror: false,
          tempdomainnamedev: value,
        });
      } else {
        setIsInput({
          ...isInput,
          tempdomainnamedeverror: false,
          tempdomainnamedev: value,
        });
      }
    } else if (type === "WordPress Admin Username") {
      value = value.toLowerCase().replace(/[^a-zA-Z0-9]/g, "");
      setIsInput({
        ...isInput,
        wordpressusernamedeverror: false,
        wordpressusernamedev: value,
      });
    } else if (type === "WordPress Admin Password") {
      value = value.replace(/\s/g, "");
      if (!verifyPassword(value)) {
        setIsInput({
          ...isInput,
          wordpresspassworddeverror: true,
          wordpresspassworddev: value,
        });
      } else {
        setIsInput({
          ...isInput,
          wordpresspassworddeverror: false,
          wordpressconfirmpassworddeverror: false,
          wordpresspassworddev: value,
        });
      }
    }
  };

  const normalizedValue = (usedCredits / (limits + stagingCredits)) * 100;

  const handlePayment = (paymentType) => {
    setIsLoading(true);
    const actionType =
      paymentType === "stripe"
        ? Actions.API_PAY_STAGING_STRIPE
        : Actions.API_PAY_STAGING_CASHFREE;

    getStore().dispatch({
      type: actionType,
      data: {
        quantity,
        priceId,
        orgId,
      },
      meta: {
        onSuccess: (data) => {
          setIsLoading(false);
          setIsExtend(false);
          setQuantity(0);
          ActivatePopup("success_staging");

          const cleanedData = data.replace(/\\/g, "");

          window.open(cleanedData, "_blank");
        },
        onError: () => {
          setIsLoading(false);
          setIsExtend(false);
          setQuantity(0);
          ActivatePopup("error");
        },
      },
    });
  };

  const handlePayStripeStaging = () => handlePayment("stripe");
  const handlePayCashfreeStaging = () => handlePayment("cashfree");

  return (
    <>
      <Grid2 className={styles.WordpressContainer}>
        <Grid2
          className={
            dedicatedHosting ? styles.dedicatedHosting : styles.AdminFlexBox
          }
        >
          <Grid2 className={styles.AdminWidth}>
            <CustomInput
              id="createsiteform-sitename"
              title="Site Name"
              SubTitle="A unique identifier for your website, used exclusively within Rocon for easy reference and management."
              placeholder="Enter Site Name"
              value={isInput?.sitename}
              setValue={(e, name) => {
                fromFieldUpdate(e, name);
              }}
              error={
                isInput?.sitenameerror ||
                nameValid === false ||
                (isInput?.sitename?.length > 0 &&
                  isInput?.sitename?.length <= minLength) ||
                isInput?.sitename?.length >= maxLength
              }
              errorMessage={
                isInput?.sitename?.length > 0 &&
                isInput?.sitename?.length <= minLength
                  ? "Site name must be above " + minLength + " characters"
                  : isInput?.sitename?.length >= maxLength
                    ? "Site name should not exceed 24 letters"
                    : isInput?.sitenameerror || nameValid === false
                      ? isInput?.sitenameErrorMessage
                      : ""
              }
              nameLoading={nameLoading}
              suffix={
                isInput?.sitename?.length > 0 ? (
                  nameLoading ? (
                    <CircularProgress size={20} />
                  ) : nameValid ? (
                    <CheckCircleOutlineOutlinedIcon
                      style={{ color: "green" }}
                    />
                  ) : nameValid === false ? (
                    <HighlightOffIcon style={{ color: "red" }} />
                  ) : null
                ) : null
              }
            />
          </Grid2>
          <Grid2 className={styles.AdminWidth}>
            <CustomInput
              title={"Temporary Domain Name"}
              SubTitle="A placeholder domain that appears at the top of your site pages and can be updated anytime."
              placeholder={"Temporary Domain Name"}
              value={isInput?.tempdomainname}
              disabled={true}
              setValue={(e, name) => {
                fromFieldUpdate(e, name);
              }}
              suffix={isInput.tempdomainsuffix}
              error={isInput.tempdomainnameerror}
            />
          </Grid2>
        </Grid2>
        {!dedicatedHosting && (
          <>
            <CustomInput
              title="WordPress Admin Username"
              placeholder="Enter Wordpress Username"
              value={isInput.wordpressusername}
              setValue={(e, name) => {
                fromFieldUpdate(e, name);
              }}
              suffix={
                isInput?.tempdomainname?.length > 0
                  ? "_" + isInput?.tempdomainname
                  : ""
              }
              error={isInput.wordpressusernameerror}
            />
            <Grid2 className={styles.AdminFlexBox}>
              <Grid2 className={styles.AdminWidth}>
                <CustomInput
                  title="WordPress Admin Password"
                  placeholder="Enter Wordpress Password"
                  value={isInput.wordpresspassword}
                  setValue={(e, name) => {
                    fromFieldUpdate(e, name);
                  }}
                  autocomplete={"off"}
                  password={true}
                  error={isInput.wordpresspassworderror}
                  errorMessage={
                    !verifyPassword(isInput?.wordpresspassworddev)
                      ? isInput.wordpresspasswordErrorMessage
                      : null
                  }
                />
              </Grid2>
              <Grid2 className={styles.AdminWidth}>
                <CustomInput
                  title="WordPress Confirm Password"
                  placeholder="Re-Enter Wordpress Password"
                  value={isInput?.wordpressconfirmpassword}
                  setValue={(e, name) => {
                    fromFieldUpdate(e, name);
                  }}
                  autocomplete={"off"}
                  required={true}
                  error={isInput?.wordpressconfirmpassworderror}
                  errorMessage={isInput?.wordpressconfirmpassworderrormessage}
                  password={true}
                  passwordview={true}
                />
              </Grid2>
            </Grid2>
          </>
        )}
        {/* every EBS (v2) site gets SSH; the password is set here, at creation */}
        {!dedicatedHosting && !buildsV1Sites(orgId) && (
          <SshAccessOption
            password={isInput?.sshpassword || ""}
            errorMessage={sshErrorMessage}
            onPasswordChange={updateSshPassword}
          />
        )}
        <Grid2 className={styles.nameSubHeader}>
          Optimized Performance Features Enabled Automatically :
          <Grid2 className={styles.performanceContainer}>
            <Grid2 className={styles.wordPressFlexBox}>
              <CheckCircleIcon className={styles.iconColor} />
              <Grid2>
                <Grid2 className={styles.performanceSite}>
                  {WordpressConstantText.WAF.header}
                </Grid2>
                <Grid2 className={styles.performanceSubheader}>
                  {WordpressConstantText.WAF.subheader}
                </Grid2>
              </Grid2>
            </Grid2>
            <Grid2 className={styles.wordPressFlexBox}>
              <CheckCircleIcon className={styles.iconColor} />
              <Grid2>
                <Grid2 className={styles.performanceSite}>
                  {WordpressConstantText.CDN.header}
                </Grid2>
                <Grid2 className={styles.performanceSubheader}>
                  {WordpressConstantText.CDN.subheader}
                </Grid2>
              </Grid2>
            </Grid2>
          </Grid2>
        </Grid2>

        {/* New managed sites are EBS (v2) sites and those have no staging
            environment, so the option is only offered to the orgs that still
            build v1 sites. Flip STAGING_AT_CREATE to offer it to everyone. */}
        {!dedicatedHosting && (STAGING_AT_CREATE || buildsV1Sites(orgId)) && (
          <>
            {!showEnvironment ? (
              <Grid2
                className={styles.EnvironmentButton}
                onClick={handleAddEnvironment}
              >
                Add Staging Environment
              </Grid2>
            ) : (
              <Grid2 className={styles.Environment}>
                <Grid2
                  className={styles.DeleteEnvironment}
                  onClick={handleDeleteEnvironment}
                >
                  Remove Environment
                </Grid2>
              </Grid2>
            )}
          </>
        )}

        <Grid2
          ref={targetRef}
          className={`${showEnvironment ? styles.EnvironmentContainer : ""}`}
        >
          {showEnvironment && (
            <>
              <Grid2>
                <Grid2 className={styles.developmentHeader}>
                  Set Up Login Details for Staging Environment
                </Grid2>
                <Grid2 className={styles.developmentSubHeader}>
                  Create secure login credentials for accessing your staging
                  environment and managing your WordPress site with ease
                </Grid2>
              </Grid2>
              <Grid2 className={styles.displayFlex}>
                <Grid2
                  className={`${styles.progressContainer} ${
                    usedCredits === limits + stagingCredits
                      ? styles.redColor1
                      : ""
                  }`}
                >
                  <Grid2 className={styles.trialText}>
                    {limits + stagingCredits > 10
                      ? "Remaining Hours of Staging"
                      : "10-hour Free Trial Remaining"}
                  </Grid2>
                  <Grid2
                    className={`${styles.progressLabel} ${
                      usedCredits === limits + stagingCredits
                        ? styles.redColor
                        : ""
                    }`}
                  >
                    <LinearProgress
                      variant="determinate"
                      value={normalizedValue}
                      sx={{
                        width: "100%",
                        height: "10px",
                        borderRadius: "5px",
                        backgroundColor: "#f0f3f8",
                      }}
                    />
                    <Grid2 className={styles.hourseContainer}>
                      <span className={styles.hoursLabel}>{usedCredits}</span>
                      <span className={styles.hoursLabel1}>
                        <span>/{stagingCredits + limits}</span>{" "}
                        <span> Hrs</span>
                      </span>
                    </Grid2>
                  </Grid2>
                  {usedCredits === limits + stagingCredits && (
                    <Grid2 className={styles.noteLabel}>
                      Note: You've exhausted your credits, please add credits to
                      your plan
                    </Grid2>
                  )}
                </Grid2>

                {usedCredits === limits + stagingCredits && (
                  <Grid2 className={styles.progress}>
                    <CustomButton
                      className={styles.addButton}
                      onClick={() => {
                        handleSlider();
                      }}
                    >
                      Add New
                    </CustomButton>
                  </Grid2>
                )}
              </Grid2>

              {usedCredits !== limits + stagingCredits ? (
                <>
                  <CustomInput
                    id="createsiteform-tempdomainnamedev"
                    title={"Temporary Domain Name"}
                    SubTitle="This will appear as the domain at the top of your site pages. You can modify it anytime"
                    placeholder={"Enter Temporary Domain Name"}
                    value={isInput?.tempdomainnamedev}
                    setValue={(e, name) => {
                      fromFieldUpdateEnv(e, name);
                    }}
                    suffix={isInput.tempdomainsuffix}
                    error={
                      isInput?.tempdomainnamedeverror ||
                      (isInput?.tempdomainnamedev &&
                        (isInput.tempdomainnamedev.length <= minLength ||
                          isInput.tempdomainnamedev.length >= maxLength ||
                          isInput.tempdomainnamedev === isInput?.sitename))
                    }
                    errorMessage={
                      isInput?.tempdomainnamedev
                        ? isInput?.tempdomainnamedev?.length <= minLength
                          ? "Temporary domain name must be above " +
                            minLength +
                            " characters"
                          : isInput?.tempdomainnamedev?.length >= maxLength
                            ? "Temporary domain name should not exceed 24 letters"
                            : isInput?.tempdomainnamedeverror
                              ? isInput?.tempdomainnamedevErrorMessage
                              : isInput?.tempdomainnamedev === isInput?.sitename
                                ? "Temporary domain name cannot be the same as the site name"
                                : ""
                        : null
                    }
                  />

                  <Grid2 className={styles.AdminFlexBox}>
                    <Grid2 className={styles.AdminWidth}>
                      <CustomInput
                        title="WordPress Admin Username"
                        placeholder="Enter Wordpress Username"
                        value={isInput?.wordpressusernamedev}
                        setValue={(e, name) => {
                          fromFieldUpdateEnv(e, name);
                        }}
                        suffix={
                          isInput?.tempdomainnamedev?.length > 0
                            ? "_" + isInput?.tempdomainnamedev
                            : ""
                        }
                        error={isInput?.wordpressusernamedeverror}
                      />
                    </Grid2>
                    <Grid2 className={styles.AdminWidth}>
                      <CustomInput
                        title="WordPress Admin Password"
                        placeholder="Enter Wordpress Password"
                        value={isInput?.wordpresspassworddev}
                        setValue={(e, name) => {
                          fromFieldUpdateEnv(e, name);
                        }}
                        autocomplete={"off"}
                        password={true}
                        passwordview={true}
                        error={isInput?.wordpresspassworddeverror}
                        errorMessage={
                          !verifyPassword(isInput?.wordpresspassworddev)
                            ? isInput.wordpresspasswordErrorMessage
                            : null
                        }
                      />
                    </Grid2>
                  </Grid2>
                </>
              ) : (
                ""
              )}
            </>
          )}
        </Grid2>
      </Grid2>
      <NewPopup
        trigger={isExtend}
        header={"Product Entensions"}
        customWidth={"30%"}
        backPopup={"Close"}
        backOnClick={() => {
          setIsExtend(false);
          setIsChecked(false);
        }}
        nextpopup={"Pay Now"}
        nextOnClick={
          selectedCountry === "India"
            ? handlePayCashfreeStaging
            : handlePayStripeStaging
        }
        disabled={!isChecked || quantity === 0}
      >
        <BuyStaging
          country={selectedCountry}
          quantity={quantity}
          setQuantity={setQuantity}
          isChecked={isChecked}
          setIsChecked={setIsChecked}
        />
      </NewPopup>
      <section>
        <FormPopup
          trigger={popup.popupState}
          setTrigger={setPopup}
          type={popup.popupType}
          title={popup.popupTitle}
          subtitle={popup.popupSubtitle}
          button={popup.popupButton}
          cancel={popup.popupCancel}
          buttonTitle={popup.popupButtonTitle}
          buttonFunction={popup.popupButtonFunction}
          loading={isLoading}
        />
      </section>
    </>
  );
}
    